import { render, staticRenderFns } from "./back.vue?vue&type=template&id=0ada7490&scoped=true&"
var script = {}
import style0 from "./back.vue?vue&type=style&index=0&id=0ada7490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada7490",
  null
  
)

export default component.exports